import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: normal;\n  height: 16px;\n  text-align: center;\n  margin: 0;\n  opacity: 0.6;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 22px;\n  text-align: center;\n  margin-bottom: 6px;\n  margin-top: 0;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  font-family: 'Avenir Next';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 22px;\n  text-align: center;\n  align-items: center;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  width: 171px;\n  height: 42px;\n  margin: 20px 0px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  height: 100%;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 30px;\n  margin-top: 76px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 356px;\n  background-color: ", ";\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Avenir Next';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 38px;\n  color: ", ";\n  white-space: pre-line;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  min-width: 350px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 33%;\n  margin: 50px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  justify-content: space-between;\n  max-width: ", "px;\n  height: 340px;\n  border-radius: 10px;\n  margin: auto;\n  background-color: ", ";\n  z-index: 1;\n  overflow: hidden;\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  flex-grow: 1;\n  position: relative;\n  z-index: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  flex-grow: 1;\n  position: relative;\n  z-index: 0;\n  margin-bottom: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { AcornsIcon } from '@acorns/icons';
import { A4_Spinner } from '../A4_Spinner';
import styled from '../utils/styling/styled-components';
import { theme } from '../theme';
import { Button } from '../Button';
import { ErrorState } from '../ErrorState';
import { BannerType } from './types';
var DEFAULT_MAX_WIDTH = 1240;
var Wrapper = styled.div(_templateObject());
var MobileWrapper = styled.div(_templateObject2());
var Container = styled.div(_templateObject3(), function (props) {
  return props.maxWidth;
}, theme.colors.green);
var Content = styled.div(_templateObject4());
var ContentContainer = styled.div(_templateObject5());
var TitleContainer = styled.div(_templateObject6());
var Title = styled.div(_templateObject7(), theme.colors.white);
var MobileContainer = styled.div(_templateObject8(), theme.colors.green);
var MobileTitleContainer = styled.div(_templateObject9());
var GraphicContainer = styled.div(_templateObject10());
var CTAButton = styled(Button)(_templateObject11());
var CTAText = styled.div(_templateObject12());
var SubtitleContainer = styled.div(_templateObject13());
export var ErrorMessage = styled.p(_templateObject14());
export var ErrorSubMessage = styled.p(_templateObject15());
export var HERO_BANNER_TITLE_TEXT_ID = 'hero_banner_title_text';
export var HERO_BANNER_TITLE_TEXT_MOBILE_ID = 'hero_banner_title_text';
export var HERO_BANNEER_CONTENT_ID = 'hero_banner_content';
export var HERO_BANNER_CTA_BUTTON_ID = 'hero_ banner_cta_button';

var NonStandardContent = function NonStandardContent(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    "data-testid": HERO_BANNEER_CONTENT_ID
  }, content);
};

var MobileHero = function MobileHero(_ref2) {
  var titleText = _ref2.titleText,
      cta = _ref2.cta,
      handleCTA = _ref2.handleCTA,
      heroImage = _ref2.heroImage,
      subtitle = _ref2.subtitle,
      loading = _ref2.loading,
      bannerType = _ref2.bannerType,
      content = _ref2.content,
      error = _ref2.error,
      handleError = _ref2.handleError;

  if (loading) {
    return /*#__PURE__*/React.createElement(MobileContainer, null, /*#__PURE__*/React.createElement(A4_Spinner, null), /*#__PURE__*/React.createElement(GraphicContainer, null, typeof heroImage === 'function' ? heroImage() : heroImage));
  }

  if (error) {
    return /*#__PURE__*/React.createElement(MobileContainer, null, /*#__PURE__*/React.createElement(ErrorState, {
      onClickReload: handleError
    }), /*#__PURE__*/React.createElement(GraphicContainer, null, typeof heroImage === 'function' ? heroImage() : heroImage));
  }

  return /*#__PURE__*/React.createElement(MobileContainer, null, bannerType === BannerType.NON_STANDARD ? /*#__PURE__*/React.createElement(NonStandardContent, {
    content: content
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileTitleContainer, null, /*#__PURE__*/React.createElement(Title, {
    "data-testid": HERO_BANNER_TITLE_TEXT_MOBILE_ID
  }, "".concat(titleText)), cta && /*#__PURE__*/React.createElement(CTAButton, {
    onPress: handleCTA,
    styleType: "dark"
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    width: "24px",
    icon: cta.icon
  }), /*#__PURE__*/React.createElement(CTAText, null, cta.text)), subtitle && /*#__PURE__*/React.createElement(SubtitleContainer, null, subtitle)), /*#__PURE__*/React.createElement(GraphicContainer, null, typeof heroImage === 'function' ? heroImage() : heroImage)));
};

var DesktopHero = function DesktopHero(_ref3) {
  var maxWidth = _ref3.maxWidth,
      bannerType = _ref3.bannerType,
      content = _ref3.content,
      titleText = _ref3.titleText,
      cta = _ref3.cta,
      subtitle = _ref3.subtitle,
      handleCTA = _ref3.handleCTA,
      heroImage = _ref3.heroImage,
      loading = _ref3.loading,
      error = _ref3.error,
      handleError = _ref3.handleError;

  if (loading) {
    return /*#__PURE__*/React.createElement(Container, {
      maxWidth: maxWidth
    }, /*#__PURE__*/React.createElement(A4_Spinner, null), /*#__PURE__*/React.createElement(GraphicContainer, null, typeof heroImage === 'function' ? heroImage() : heroImage));
  }

  if (error) {
    return /*#__PURE__*/React.createElement(Container, {
      maxWidth: maxWidth
    }, /*#__PURE__*/React.createElement(ErrorState, {
      onClickReload: handleError
    }), /*#__PURE__*/React.createElement(GraphicContainer, null, typeof heroImage === 'function' ? heroImage() : heroImage));
  }

  return /*#__PURE__*/React.createElement(Container, {
    maxWidth: maxWidth
  }, bannerType === BannerType.NON_STANDARD ? /*#__PURE__*/React.createElement(NonStandardContent, {
    content: content
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(Title, {
    "data-testid": HERO_BANNER_TITLE_TEXT_ID
  }, "".concat(titleText)), cta && /*#__PURE__*/React.createElement(CTAButton, {
    "data-testid": HERO_BANNER_CTA_BUTTON_ID,
    onPress: handleCTA,
    styleType: "dark"
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    width: "24px",
    icon: cta.icon
  }), /*#__PURE__*/React.createElement(CTAText, null, cta.text)), subtitle && /*#__PURE__*/React.createElement(SubtitleContainer, null, subtitle))), /*#__PURE__*/React.createElement(GraphicContainer, null, typeof heroImage === 'function' ? heroImage() : heroImage)));
};

export var A4_HeroBanner = function A4_HeroBanner(_ref4) {
  var _ref4$maxWidth = _ref4.maxWidth,
      maxWidth = _ref4$maxWidth === void 0 ? DEFAULT_MAX_WIDTH : _ref4$maxWidth,
      bannerType = _ref4.bannerType,
      titleText = _ref4.titleText,
      content = _ref4.content,
      heroImage = _ref4.heroImage,
      subtitle = _ref4.subtitle,
      cta = _ref4.cta,
      className = _ref4.className,
      handleCTA = _ref4.handleCTA,
      loading = _ref4.loading,
      error = _ref4.error,
      handleError = _ref4.handleError;
  var isDesktop = useMediaQuery({
    query: "(min-width: ".concat(theme.breakpoints.sm + 1, "px)")
  });
  var isMobile = useMediaQuery({
    query: "(max-width: ".concat(theme.breakpoints.sm, "px)")
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, isDesktop && /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(DesktopHero, {
    error: error,
    maxWidth: maxWidth,
    bannerType: bannerType,
    content: content,
    titleText: titleText,
    subtitle: subtitle,
    cta: cta,
    handleCTA: handleCTA,
    heroImage: heroImage,
    loading: loading,
    handleError: handleError
  })), isMobile && /*#__PURE__*/React.createElement(MobileWrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(MobileHero, {
    bannerType: bannerType,
    titleText: titleText,
    subtitle: subtitle,
    cta: cta,
    handleCTA: handleCTA,
    heroImage: heroImage,
    content: content,
    loading: loading,
    handleError: handleError,
    error: error
  })));
};